import styled from "styled-components";
import React from "react";

export interface TabList {
  label: string;
  value: string;
}
type SettingsProps = {
  active?: number;
  onChange?: (data: { index: number; data: any }) => void;
  options?: TabList[];
};
export const SettingsTabs: React.FC<SettingsProps> = ({
  active,
  onChange,
  options,
}) => {
  const tabs = options ?? [];

  return tabs.length ? (
    <TabContainer>
      <TabArea>
        {tabs.map((tab, index) => (
          <Tab
            onClick={() => onChange?.({ index, data: tab })}
            $active={index === active}
          >
            {tab?.label}
          </Tab>
        ))}
      </TabArea>
    </TabContainer>
  ) : null;
};

const TabContainer = styled.section`
  width: calc(100% - 40px);
  background-color: white;
  padding: 20px;
  border-radius: 10px;

  @media screen and (max-width: 768px) {
    width: calc(100% - 50px);
  }
  /* @media (min-width: 1000px) {
    min-width: 900px;
  }
  @media (max-width: 700px) {
    min-width: 500px;
  } */
`;
const TabArea = styled.div`
  width: 98%;
  padding: 6px;
  background-color: #f7f7f7;
  display: flex;
  border-radius: 10px;
`;
const Tab = styled.div<{ $active?: boolean }>`
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;
  ${({ $active }) =>
    $active
      ? `
      border: 1px solid #E8EAED;
      background:  #FFF;
      box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);
      color: #09005B;
            `
      : ""}
`;
